module.exports = __webpack_public_path__ + "static/media/woman.807b4285.png";